import { loadStripe } from '@stripe/stripe-js'

// The publishable key index.js loads Stripe.js with (it is hard-coded there).
// REACT_APP_STRIPE_PUBLISHABLE_KEY overrides it, e.g. a pk_test_ key locally,
// which must match the mode of dashboards-api's secret key.
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_btebNtjR3AQlGUFYNar7CdS5'

const loaded = {}

/**
 * Stripe.js for the org's connected account. The add-on's SetupIntent is
 * created on that account (like every add-on Stripe write), so it must be
 * confirmed with { stripeAccount } too. One instance per account.
 */
export const connectedStripe = (connectedAccountId) => {
    if (!loaded[connectedAccountId]) {
        loaded[connectedAccountId] = loadStripe(STRIPE_PUBLISHABLE_KEY, { stripeAccount: connectedAccountId })
    }
    return loaded[connectedAccountId]
}
